module.exports = __webpack_public_path__ + "static/media/bmw_apps_filter.f9a8b9c5.svg";